module.exports = __webpack_public_path__ + "img/activity-1@2x.22624657.svg";